import Swiper from "swiper";
import { Navigation, Autoplay } from 'swiper/modules';
import {mediaQueryBreakpointSM, mediaQueryBreakpointMD} from "../../utils/Utils.js";

const Slideshow = (domEl) => {

	const slideshowEl = domEl.querySelector('.swiper');
	if(!slideshowEl) {
		return;
	}

	const titles = domEl.querySelectorAll('.context .title');

	const renderTitle = (realIndex) => {
		titles.forEach((title, index) => {
			if(index === realIndex) {
				title.classList.add('js-active');
			}
			else {
				title.classList.remove('js-active');
			}
		})
	}

	const swiper = new Swiper(slideshowEl, {
		modules:[Navigation, Autoplay],
		loop: true,
		/*
		autoplay: {
			delay: 2500,
		},
		*/
		speed: 500,
		spaceBetween: 15,
		slidesPerView: 'auto',
		centeredSlides: true,
		navigation: {
			nextEl: domEl.querySelector('.swiper-button-next'),
			prevEl: domEl.querySelector('.swiper-button-prev'),
		},
		breakpoints: {
			[mediaQueryBreakpointSM]: {
				spaceBetween: 30,
			},
			[mediaQueryBreakpointMD]: {
				spaceBetween: 60,
			}
		},
		on: {
			init: () => {
				domEl.classList.add('js-init');
			}
		}
	});
	swiper.on('realIndexChange', (swiper) => {
		renderTitle(swiper.realIndex);
	})
	renderTitle(0);
};

export default Slideshow;